
import { IGlobalState } from "@/store";
import {
  computed,
  defineComponent,
  onMounted,
  reactive,
  ref,
  toRefs,
} from "vue";
import { useStore } from "vuex";
import { useAppAuthedAPI } from "@/hooks/apiManage";
import { useRouter } from "vue-router";
import { EXAMINE_STATE } from "@/typings/factory";
import applyApi from "./modules/applyApi.vue";
import { cancelAppApi } from "@/service/api";
import { ElMessage } from "element-plus";
import { IAPIItem } from "@/typings/apiManage";

export default defineComponent({
  components: {
    applyApi,
  },
  setup() {
    const store = useStore<IGlobalState>();
    const router = useRouter();
    const state = reactive({
      userId: computed(() => store.state.user.id),
      appId: router.currentRoute.value.query.appid,
      examineStateList: [
        {
          lable: "未审核",
          value: EXAMINE_STATE.NOEXAMINE,
        },
        {
          lable: "通过",
          value: EXAMINE_STATE.PASS,
        },
        {
          lable: "未通过",
          value: EXAMINE_STATE.NOPASS,
        },
        {
          lable: "全部状态",
          value: -1,
        },
      ],
      cancelDialogVisible:false,
      cancelAppApiId:'',
      clickModalClose:false
    });
    // 获取关键字
    const keyWord = computed({
      get: () => store.state.apiManage.keyWord,
      set: (val) => {
        store.state.apiManage.keyWord = val;
      },
    });
    // 审核状态
    const examineState = computed({
      get: () => store.state.apiManage.examineState,
      set: (val) => {
        store.state.apiManage.examineState = val;
      },
    });
    // 已申请API
    const authApis = computed(() => store.state.apiManage.apis);

    // 获取当前页码数
    const page = computed({
      get: () => store.state.apiManage.apis.page,
      set: (val) => {
        store.state.apiManage.apis.page = val;
      }
    });
    console.log('page='+page.value);
    // 申请窗口是否可见状态
    const visibleModal = ref(false);
    /**
     * 获取应用已申请API列表
     */
    const getAuthAPIs = async () => {
      await useAppAuthedAPI(
        store,
        state.userId,
        state.appId,
        examineState.value,
        keyWord.value,
        page.value,
        authApis.value.limit
      );
    };
    /**
     * 搜索
     */
    async function handleSearch() {
      page.value = 1;
      await getAuthAPIs();
    }
    /**
     * 点击取消授权
     */
    function wantCancelAuth(row: IAPIItem){
      state.cancelAppApiId = row.id
      state.cancelDialogVisible = true;
    }
    /**
     * 取消API申请
     */
    async function cancelAuthAPI() {
      const params = {
        id: state.cancelAppApiId,
      };
      const result = await cancelAppApi(params);
      if (result.code == 1) {
        ElMessage({ message: "取消申请成功", type: "success" });
        state.cancelDialogVisible = false;
        await getAuthAPIs();
      } else {
        ElMessage({ message: result.msg, type: "error" });
      }
    }
    /**
     * 打开申请API弹框
     */
    function openSelectApi() {
      visibleModal.value = true;
    }
    /**
     * 关闭申请API弹框
     */
    function closeModal() {
      visibleModal.value = false;
    }
    /**
     * 分页改变是回调方法
     */
    async function changePage(cueerntPage: number){
      page.value = cueerntPage;
      await getAuthAPIs();
    }
    /**
     * 页面一开始加载就调用API列表
     */
    onMounted(async () => {
      await getAuthAPIs();
    });
    return {
      ...toRefs(state),
      keyWord,
      examineState,
      page,
      authApis,
      getAuthAPIs,
      visibleModal,
      handleSearch,
      cancelAuthAPI,
      openSelectApi,
      closeModal,
      wantCancelAuth,
      changePage
    };
  },
});
